import React from 'react';
import { IFilter, IFilterValueSelectorProps } from './interfaces';
import DateSelector from './DateSelector';
import DropdownSelector from './DropdownSelector';
import BooleanSelector from './BooleanSelector';
import TagFilterSelector from './TagFilterSelector';
import AccountFilterSelector from './AccountFilterSelector';
import EmployeeFilterSelector from './EmployeeFilterSelector';
import { Box, SxProps, Typography } from '@mui/material';
import _ from 'lodash';

const SELECTOR_MAP: Record<IFilter['type'], React.FC<IFilterValueSelectorProps>> = {
  date: DateSelector,
  dropdown: DropdownSelector,
  boolean: BooleanSelector,
  employee: EmployeeFilterSelector,
  account: AccountFilterSelector,
  tag: TagFilterSelector,
};

const sectionSx: SxProps = { pb: 2, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 1 };

interface IRenderSelectorProps {
  filter: IFilter;
  values: (string | null)[];
  onChange: (key: string, vals: (string | null)[]) => void;
}

export default function RenderSelector({ filter, values, onChange }: IRenderSelectorProps) {
  const handleChange = (vals: (string | null)[]) => {
    const normalizedVals = _(vals).map(v => _.trim(v ?? undefined) ? v : null).value();
    if (_.isEqual(values, normalizedVals)) return;

    onChange(filter.key, normalizedVals);
  };

  const Selector = SELECTOR_MAP[filter.type];
  return (
    <Box sx={sectionSx}>
      <Typography variant="subtitle2" gutterBottom>
        {filter.label}
      </Typography>
      <Selector filterValues={values || []} setFilterValues={handleChange} options={filter.options || []} />
    </Box>
  );
}
